import { useCallback } from 'react';
import { useDevicePanel } from '@ubnt/link-core-ui/components/BottomPanel/context/DevicePanelContext';
import { useDispatch, useSelector } from 'app/store';
import {
  devicesDeviceIsOutdoorModeSelector,
  devicesOutdoorToggle,
  devicesDeviceSupportsOutdoorMode,
} from 'modules/devices/slice';
import { trackEvent } from 'utils/googleAnalytics';
import OutdoorSwitch, { OutdoorSwitchProps } from 'modules/bottomPanel/components/elements/OutdoorSwitch';
import { settingsCountrySelector } from 'modules/settings/slice';

export interface OutdoorSwitchContainerProps extends Partial<OutdoorSwitchProps> {
  id: string;
}

const OutdoorSwitchWithIdContainer = (props: OutdoorSwitchContainerProps) => {
  const { id } = props;

  const dispatch = useDispatch();
  const supportsOutdoorMode = useSelector((state) => devicesDeviceSupportsOutdoorMode(state, id));
  const isOutdoorMode = useSelector((state) => devicesDeviceIsOutdoorModeSelector(state, id));
  const country = useSelector(settingsCountrySelector);

  const onClick = useCallback(() => {
    dispatch(devicesOutdoorToggle({ id, country }));
    trackEvent('bottomPanelOutdoorToggle', { isOutdoor: String(isOutdoorMode) });
  }, [dispatch, id, isOutdoorMode, country]);

  if (!supportsOutdoorMode) {
    return null;
  }

  return <OutdoorSwitch onClick={onClick} isOutdoor={isOutdoorMode ?? false} />;
};

const OutdoorSwitchContainer = () => {
  const { id } = useDevicePanel();

  if (!id) {
    return null;
  }

  return <OutdoorSwitchWithIdContainer id={id} />;
};

export default OutdoorSwitchContainer;
